module.exports = __webpack_public_path__ + "static/media/placeholder_video.569a2ed0.jpg";